import React from 'react'
import ArrowUpOutlined from '@ant-design/icons/ArrowUpOutlined'
import BankOutlined from '@ant-design/icons/BankOutlined'
import BarChartOutlined from '@ant-design/icons/BarChartOutlined'
import CaretDownOutlined from '@ant-design/icons/CaretDownOutlined'
import CaretUpOutlined from '@ant-design/icons/CaretUpOutlined'
import CheckCircleOutlined from '@ant-design/icons/CheckCircleOutlined'
import CheckOutlined from '@ant-design/icons/CheckOutlined'
import CloseCircleOutlined from '@ant-design/icons/CloseCircleOutlined'
import ContainerOutlined from '@ant-design/icons/ContainerOutlined'
import CopyOutlined from '@ant-design/icons/CopyOutlined'
import DatabaseOutlined from '@ant-design/icons/DatabaseOutlined'
import DoubleLeftOutlined from '@ant-design/icons/DoubleLeftOutlined'
import DoubleRightOutlined from '@ant-design/icons/DoubleRightOutlined'
import DownOutlined from '@ant-design/icons/DownOutlined'
import ExclamationCircleOutlined from '@ant-design/icons/ExclamationCircleOutlined'
import FileDoneOutlined from '@ant-design/icons/FileDoneOutlined'
import HomeFilled from '@ant-design/icons/HomeFilled'
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined'
import LeftOutlined from '@ant-design/icons/LeftOutlined'
import LoadingOutlined from '@ant-design/icons/LoadingOutlined'
import MinusCircleOutlined from '@ant-design/icons/MinusCircleOutlined'
import PlusCircleOutlined from '@ant-design/icons/PlusCircleOutlined'
import PrinterFilled from '@ant-design/icons/PrinterFilled'
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined'
import RightOutlined from '@ant-design/icons/RightOutlined'
import SearchOutlined from '@ant-design/icons/SearchOutlined'
import SettingOutlined from '@ant-design/icons/SettingOutlined'
import TeamOutlined from '@ant-design/icons/TeamOutlined'
import UploadOutlined from '@ant-design/icons/UploadOutlined'
import UserOutlined from '@ant-design/icons/UserOutlined'
import UserSwitchOutlined from '@ant-design/icons/UserSwitchOutlined'
import WarningOutlined from '@ant-design/icons/WarningOutlined'
import WarningTwoTone from '@ant-design/icons/WarningTwoTone'
import classNames from 'classnames'

import styles from './Icons.module.scss'

interface HasClassName {
  className?: string
}

export const DocumentIcon = (): JSX.Element => {
  return (
    <svg
      width='24'
      height='24'
      xmlns='http://www.w3.org/2000/svg'
      fillRule='evenodd'
      clipRule='evenodd'
    >
      <path d='M22 24h-20v-24h14l6 6v18zm-7-23h-12v22h18v-16h-6v-6zm3 15v1h-12v-1h12zm0-3v1h-12v-1h12zm0-3v1h-12v-1h12zm-2-4h4.586l-4.586-4.586v4.586z' />
    </svg>
  )
}
interface Disabled {
  disabled?: boolean
}

export const ArrowIcon: React.FC<Disabled & { direction: 'top' | 'left' | 'bottom' | 'right' }> = ({
  disabled,
  direction,
}) => {
  let rotateDeg = 0
  if (direction === 'top') {
    rotateDeg = 90
  } else if (direction === 'right') {
    rotateDeg = 180
  } else if (direction === 'bottom') {
    rotateDeg = 270
  }

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='8' height='9' viewBox='0 0 8 9'>
      <path
        fill={disabled ? styles.disabledColor : styles.defaultColor}
        transform={`rotate(${rotateDeg} 4 4.5)`}
        fillRule='evenodd'
        d='M.674 3.308L5.999.183C6.891-.34 8 .32 8 1.374v6.252C8 8.68 6.89 9.34 5.999 8.817L.674 5.693c-.899-.527-.899-1.857 0-2.385'
      />
    </svg>
  )
}

export const LinkIcon: React.FC<Disabled & HasClassName> = ({ disabled, className }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'>
      <g className={classNames(className, disabled ? styles.disabled : styles.normal)}>
        <path d='M5.077 13.575c-.732.733-1.92.733-2.652 0-.721-.72-.733-1.883-.034-2.617l3.952-3.952c-1.222-.327-2.578-.026-3.555.903L1.031 9.666c-1.397 1.47-1.374 3.794.068 5.235 1.464 1.465 3.84 1.465 5.304 0l1.62-1.62c.982-.981 1.306-2.372.972-3.623l-3.918 3.917zM14.901 1.1C13.46-.344 11.136-.367 9.666 1.03L7.91 2.788c-.93.977-1.23 2.333-.903 3.555l3.952-3.952c.734-.699 1.897-.687 2.617.034.733.732.733 1.92 0 2.652L9.658 8.995c1.25.334 2.642.01 3.623-.972l1.62-1.62c1.465-1.464 1.465-3.84 0-5.304z' />
        <path d='M5.15 10.85c.365.367.96.367 1.325 0l4.376-4.375c.366-.366.366-.96 0-1.326-.36-.36-.942-.366-1.309-.017l-4.41 4.41c-.35.367-.343.949.017 1.309z' />
      </g>
    </svg>
  )
}

export {
  TeamOutlined,
  DownOutlined,
  LeftOutlined,
  ArrowUpOutlined,
  UserOutlined,
  UploadOutlined,
  DatabaseOutlined,
  SettingOutlined,
  SearchOutlined,
  InfoCircleOutlined,
  WarningOutlined,
  WarningTwoTone,
  CheckOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
  PrinterFilled,
  HomeFilled,
  CaretUpOutlined,
  CaretDownOutlined,
  ContainerOutlined,
  BarChartOutlined,
  BankOutlined,
  FileDoneOutlined,
  CheckCircleOutlined,
  QuestionCircleOutlined,
  ExclamationCircleOutlined,
  UserSwitchOutlined,
  RightOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
  CopyOutlined,
}

export { LogoIcon, LogoTextIcon } from './LogoIcon'
export { Icon } from './IconContainer'
export { HeaderLogoIcon } from './HeaderLogoIcon'
